export function getPropertyByPath(obj, path) {
    const properties = path.split('.');
    let value = obj;

    for (let prop of properties) {
        if (Array.isArray(value)) {
            value = value.map(item => item[prop]);
        } else {
            value = value[prop];
        }
        if (value === undefined) {
            break;
        }
    }
    
    return value;
}

export const checkObjEquality = (obj1, obj2) => {
    if (obj1 === obj2) {
        return true;
    }

    if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!keys2.includes(key) || !checkObjEquality(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

    
export function colorManipulationToBright(level, passedColor) {
    let color = passedColor.replace("#", "");
  
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    const brightenAmount = 1 + level / 100;
    const brightenedR = Math.min(Math.round(r * brightenAmount), 255);
    const brightenedG = Math.min(Math.round(g * brightenAmount), 255);
    const brightenedB = Math.min(Math.round(b * brightenAmount), 255);
  
    const brightenedColor = "#" +
      brightenedR.toString(16).padStart(2, "0") +
      brightenedG.toString(16).padStart(2, "0") +
      brightenedB.toString(16).padStart(2, "0");
  
    return brightenedColor;
}

export function handleMultipleKeys(item, keys){
    let dynamicValue = item;
    if(Array.isArray(keys)){
        for (let key of keys) {
            dynamicValue = dynamicValue[key];
        }
    } else {
        dynamicValue = dynamicValue[keys]
    }
    return dynamicValue; 
}

export const replaceSpaces = (text) => {
    return text = String(text).replaceAll(" ", "_");
}